import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import NewJob from './pages/NewJob';
import Machines from './pages/Machines';
import Parts from './pages/Parts';
import EngineeringRules from './pages/EngineeringRules';
import Settings from './pages/Settings';
import { useAppStore } from './store';
import { seedDemoData } from './demoData';

export default function App() {
  const jobs = useAppStore(s => s.jobs);
  const addJob = useAppStore(s => s.addJob);
  const updateJob = useAppStore(s => s.updateJob);

  useEffect(() => {
    if (jobs.length === 0) {
      seedDemoData(addJob, updateJob);
    }
  }, []); // eslint-disable-line

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/new-job" element={<NewJob />} />
          <Route path="/machines" element={<Machines />} />
          <Route path="/parts" element={<Parts />} />
          <Route path="/rules" element={<EngineeringRules />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
